import cx from 'classnames';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

import AccountCircle from '@material-ui/icons/AccountCircle';
import AppBar from 'fuse-ui/components/AppBar';
import AppSwitcher from 'fuse-ui/components/AppSwitcher';
import Button from 'fuse-ui/components/Button';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import React, { Component } from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from 'fuse-ui/components/Typography';

import { PFPT_EXPERIMENTAL } from '../constants/definitions';
import { shouldOverrideNavBarColor } from '../../utils/environmental-utils';

const styles = theme => {
    return {
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
        },
        betaButton: {
            padding: '0 8px'
        },
        envMessage: {
            flex: 1,
            marginLeft: theme.spacing.unit * 3
        },
        menuButton: {
            marginLeft: -12,
            marginRight: 20,
        },
        navItem: {
            marginRight: 12,
        },
        rightMenu: {
            alignItems: 'center',
            display: 'flex',
            'float': 'right',
        },
        root: {
            position: 'fixed',
            width: '100%',
            zIndex: theme.zIndex.drawer + 1,
            ...theme.mixins.toolbar
        },
        spacer: {
            'flex-grow': 1
        }
    };
};

export class NavBar extends Component{
    constructor( props ){
        super( props );
        this.state = {
            anchorEl: null
        };
    }

    handleMenu = event => {
        this.setState( { anchorEl: event.currentTarget } );
    };

    handleClose = () => {
        this.setState( { anchorEl: null } );
    };

    handleLogout = () => {
        this.setState( { anchorEl: null } );
        this.props.onLogout();
    };

    formatAppItems = () => {
        const { appItems } = this.props;
        return (
            [{
                header: 'Apps',
                options: appItems.map( ( appItem ) => ( {
                    key: appItem.appId,
                    label: appItem.displayName,
                    onClick: () => {
                        window.location.assign( appItem.appUrl );
                    },
                    selected: appItem.appId === 'efd'
                } ) )
            }]
        );
    }

    toggleExperimentalMode = () => {
        if( this.props.isExperimental ){
            sessionStorage.removeItem( PFPT_EXPERIMENTAL );
        }
        else{
            sessionStorage.setItem( PFPT_EXPERIMENTAL, true );
        }

        window.location.reload();
    }

    render(){
        const { classes, hasNewFeatureVisibility, isExperimental, navBarMessage, userInfo } = this.props;
        const { anchorEl } = this.state;

        const open = Boolean( anchorEl );
        const formattedAppItems = this.formatAppItems();
        const AppSwitch = [ 'prod', 'staging' ].indexOf( process.env.REACT_APP_STAGE ) > -1 ?
            null :
            <AppSwitcher appOptions={ formattedAppItems } appType="admin" variant="enterprise-product" />;

        return (
            <div className={cx( 'no-print', classes.root )}>
                <AppBar
                    position="static"
                    productName="Email Fraud Defense"
                    style={{ backgroundColor: shouldOverrideNavBarColor( isExperimental, process.env.REACT_APP_STAGE ) ? '#fb8c00' : null }}
                    appSwitcher={ AppSwitch }
                >
                    <Typography
                        data-automation-id="environment-message"
                        variant="subtitle1"
                        color="inherit"
                        className={classes.envMessage}
                        align="left"
                        inline
                    >
                        {navBarMessage}
                    </Typography>

                    <div className={ classes.spacer }></div>

                    <Toolbar style={{ marginRight: '0' }}>
                        <div className={classes.rightMenu} >
                            <Typography
                                variant="subtitle1"
                                color="inherit"
                                className={classes.navItem}>
                                { `${userInfo.fullname}${userInfo.fullname && userInfo.displayRealmName ? ',' : '' } ${userInfo.displayRealmName}`}
                            </Typography>
                            <IconButton
                                aria-haspopup="true"
                                aria-owns={open ? 'menu-appbar' : null}
                                className={classes.navItem}
                                color="inherit"
                                data-automation-id="superuser-account-logout"
                                onClick={this.handleMenu}
                            >
                                <AccountCircle style={{ fontSize: 24 }} />
                            </IconButton>
                            <Menu
                                className="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    horizontal: 'right',
                                    vertical: 'top',
                                }}
                                transformOrigin={{
                                    horizontal: 'right',
                                    vertical: 'top',
                                }}
                                open={open}
                                onClose={this.handleClose}
                            >
                                <MenuItem
                                    onClick={this.handleLogout}
                                    data-automation-id="logout"
                                >
                                        Logout
                                </MenuItem>
                            </Menu>
                            {
                                hasNewFeatureVisibility &&
                                ( <Button
                                    className={classes.betaButton}
                                    onClick={this.toggleExperimentalMode}
                                >
                                    { isExperimental ? 'Exit Beta Mode' : 'Switch to Beta' }
                                </Button> )
                            }
                        </div>
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
};

NavBar.propTypes = {
    appItems: PropTypes.array,
    classes: PropTypes.object,
    hasNewFeatureVisibility: PropTypes.bool.isRequired,
    history: PropTypes.any,
    isExperimental: PropTypes.bool.isRequired,
    navBarMessage: PropTypes.string,
    onLogout: PropTypes.func.isRequired,
    userInfo: PropTypes.object,
};

export default withStyles( styles )( withRouter( NavBar ) );
